<template>
  <div>
    <header
      class="bg-surface sticky top-0 z-1 border-b border-[var(--ui-border)] bg-[var(--ui-bg)] px-4 py-1 lg:px-6"
    >
      <UButton to="/" color="neutral" icon="i-ph-arrow-left" variant="ghost" />
    </header>
    <slot />
  </div>
</template>
